<template>
    <div class="view performance-workforce" v-if="loaded">
        <app-sub-navbar parent="performance"></app-sub-navbar>
        <div class="container-fluid">
            <app-graph-filter class="text-center" @filterLoaded="loadChart = true" @filterChanged="redrawComponents()" parent="performance"></app-graph-filter>

            <div class="spacer col-12"></div>

            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <el-card class="box-card" v-if="loadChart">
                        <div slot="header" class="text-left">
                            <h3>Hour distribution</h3>
                        </div>
                        <app-chart-component ref="chart1" title="hourdistribution" storeModule='budget' endpoint="/performance/workforce/hours_share"></app-chart-component>
                    </el-card>
                </div>

                <div class="spacer col-12 d-lg-none"></div>

                <div class="col-lg-6 col-md-12">
                    <el-card class="box-card" v-if="loadChart">
                        <div slot="header" class="text-left">
                            <h3>Work experience</h3>
                        </div>
                        <app-chart-component ref="chart2" title="workexperience" storeModule='budget' endpoint="/performance/workforce/work_experience"></app-chart-component>
                    </el-card>
                </div>
            </div>

            <div class="spacer col-12"></div>
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <el-card class="box-card" v-if="loadChart">
                        <div slot="header" class="text-left">
                            <h3>Age</h3>
                        </div>
                        <app-chart-component ref="chart3" title="age" storeModule='budget' endpoint="/performance/workforce/age"></app-chart-component>
                    </el-card>
                </div>

                <div class="spacer col-12 d-lg-none"></div>

                <div class="col-lg-6 col-md-12">
                    <el-card class="box-card" v-if="loadChart">
                        <div slot="header" class="text-left">
                            <h3>Hourly rate</h3>
                        </div>
                        <app-chart-component ref="chart4" title="hourlyrate" storeModule='budget' endpoint="/performance/workforce/hourly_rate"></app-chart-component>
                    </el-card>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import SubNavbar from '../../components/SubNavbar'
import ChartComponent from '../../chart/ChartComponent'
import GraphFilter from '../../components/GraphFilter'

export default {
    data () {
        return {
            loaded: false,
            loadChart: false
        }
    },
    components: {
        appSubNavbar: SubNavbar,
        appChartComponent: ChartComponent,
        appGraphFilter: GraphFilter
    },
    methods: {
        redrawComponents () {
            for (let i in this.$refs) {
                this.$refs[i].draw()
            }
        }
    },
    created () {
        if (this.$store.getters['budget/storesLoaded'] === false && this.$store.getters['general/storesLoaded'] === true) {
            this.$store.commit('budget/SET_STORES', this.$store.getters['general/getStores'])
            this.loaded = true
        } else if (this.$store.getters['budget/storesLoaded'] === false && this.$store.getters['general/storesLoaded'] === false) {
            this.$store.dispatch('general/getStores').then(response => {
                this.$store.commit('budget/SET_STORES', this.$store.getters['general/getStores'])
                this.loaded = true
            })
        } else {
            this.loaded = true
        }
    }
}
</script>
<style>
.padding-20 {
    padding-left: 20px;
    padding-right: 20px;
}
</style>
